export default function Wages(Restangular, PersonaCollection, dateFilter) {
  'ngInject';

  Restangular.addRequestInterceptor((element, operation, what) => {
    if (/^labor\/wages\/(user|position)\/bulk$/.test(what) && operation === 'put') {
      const elements = Array.isArray(element) ? element : [element];

      elements.forEach((item) => {
        item.dateEffective = dateFilter(item.fromDate, 'yyyy-MM-dd');
      });
    }

    return element;
  });

  Restangular.addResponseInterceptor((element, operation, what) => {
    if (/^labor\/wages\/(user|position)\/bulk$/.test(what) && operation === 'put') {
      const elements = Array.isArray(element) ? element : [element];
      PersonaCollection.updateWages(elements);
    }

    return element;
  });

  return Restangular.service('labor/wages');
}
